import { useDispatch, useSelector } from "react-redux";
import { showFeedModal } from "actions/modal";
import {
  getFeedMediaCount,
  getSelectedFeedIds,
} from "selectors/hashtagFeedSelectors";
import { PAGES } from "constants/MediaLibrary";
import SaveDropdown from "./SaveDropdown";

const FeedHeader = ({
  headerText,
  subtitleText,
}: {
  headerText: string;
  subtitleText: string;
}) => {
  const dispatch = useDispatch();
  const selectedFeedIds = useSelector(getSelectedFeedIds);
  const feedMediaCount = useSelector((state) =>
    getFeedMediaCount(state, PAGES.HASHTAGS)
  );

  const isDisabled = selectedFeedIds.length === 0;

  return (
    <div className="FeedHeader flex mb-2 mt-2">
      <div className="flex flex-col" style={{ flex: 2 }}>
        <div className="flex items-center">
          <div className="text-lg font-black">{headerText}</div>
          {selectedFeedIds.length > 0 && (
            <div className="ml-2 text-l text-gray-400">
              {selectedFeedIds.length} selected
            </div>
          )}
        </div>

        <div className="mt-1 text-gray-400">
          {subtitleText || `Displaying ${feedMediaCount} posts`}
        </div>
      </div>
      <SaveDropdown
        disabled={isDisabled}
        onSave={() => dispatch(showFeedModal())}
      />
    </div>
  );
};

export default FeedHeader;
